module.exports = __webpack_public_path__ + "static/austin_college-7a3e823dd22615d37960b12fa87626bc.jpg";